import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { computed } from 'vue';

import { useUserStore } from '@/helpers/composables/useStores';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { OfferPresentationType } from '@/interfaces/titles';
import { BuyBoxFilterOptions } from '@/stores/user.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailJumpLinksV1',
  props: {
    visibleSectionState: null,
    container: { default: null }
  },
  setup(__props: any) {

const props = __props as { visibleSectionState: Record<string, boolean>, container: HTMLElement | null };



const { tc } = useI18n();
const { setBuyboxPresentationType, setNewBuyboxFilterType } = useUserStore();

const links = computed<
	{
		id: string;
		text: string;
		callback?: (parent: HTMLElement | Document) => void;
	}[]
>(() => {
	return [
		{
			id: 'where-to-watch',
			text: tc('WEBAPP_WHERE_TO_WATCH'),
			callback: _ => {
				setBuyboxPresentationType({ presentationType: null });
				setNewBuyboxFilterType(BuyBoxFilterOptions.ALL);
			},
		},
		{
			id: 'regular-buybox',
			text: tc('WEBAPP_WATCH_FOR_FREE'),
			callback: _ => {
				setBuyboxPresentationType({ presentationType: OfferPresentationType.FREE });
				setNewBuyboxFilterType(BuyBoxFilterOptions.FREE);
			},
		},
		{
			id: 'episodes-lists',
			text: tc('WEBAPP_EPISODES'),
		},
		{
			id: 'synopsis',
			text: tc('WEBAPP_SYNOPSIS'),
		},
		{
			id: 'why-to-watch',
			text: tc('WEBAPP_WHY_TO_WATCH'),
		},
		{
			id: 'trailers',
			text: tc('WEBAPP_TRAILERS_SHORT'),
		},
		{
			id: 'streaming-chart',
			text: tc('WEBAPP_STREAMING_CHARTS'),
		},
		{
			id: 'similar-content',
			text: tc('WEBAPP_SIMILAR_TITLES'),
		},
	];
});

const isSectionHidden = (id: string) => {
	return props.visibleSectionState[id] === false;
};

async function scrollTo(id: string, disableTracking = false) {
	/**
	 * We are setting where-to-watch as the parent for regular-buybox because, on SeasonPages and ShowPages,
	 * we have multiple buyboxes shown simultaneously. Doing this ensures that we scroll to the correct buybox.
	 */
	const container = props.container || document;
	const parent = id === 'regular-buybox' ? container.querySelector('#where-to-watch') : container;
	const element = parent?.querySelector(`#${id}`);
	if (element) {
		// INP case: artificially give the JS thread time to breathe for upcoming scrolling
		await new Promise(resolve => setTimeout(resolve, 0));
		element.scrollIntoView({ behavior: 'smooth' });
	}

	// INP case: artificially give the JS thread time to breathe for upcoming callback like buybox filter change
	await new Promise(resolve => setTimeout(resolve, 0));
	links.value.find(link => link.id === id)?.callback?.(container);

	if (!disableTracking) {
		const label = id === 'regular-buybox' ? 'watch-for-free' : id;
		TrackingHelper.trackEvent('userinteraction', {
			action: 'jumplink_clicked',
			label: label.replaceAll('-', '_'),
		});
	}
}

return { __sfc: true,props, tc, setBuyboxPresentationType, setNewBuyboxFilterType, links, isSectionHidden, scrollTo, HiddenHorizontalScrollbar }
}

})